import { RoleService } from 'app/core/services/role/role.service';
import { AuthService } from 'app/auth/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-role',
    standalone: true,
    imports: [ TranslateModule ],
    templateUrl: './role.component.html',
    styleUrl: './role.component.scss'
})

export class RoleComponent {

	role: string = '';

	isAdmin: boolean = false;

	constructor(
		private roleService: RoleService,
		private authService: AuthService
	) {
		this.roleService.currentRole$.subscribe(role => {
			this.role = role;
		});
		this.isAdmin = this.isAdministrator();
	}

	private isAdministrator(): boolean {
		const roles: string[] = this.authService.getRealmRoles();
		return roles.includes('ds-catalog-administrator');
	}

	getVisibleCardsCount(): number {
		let count = 1;
		if (this.isAdmin) count++;
		return count || 1;
	}

}